module.exports = __webpack_public_path__ + "static/media/te 1.f8dd3474.png";